var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenuArrowLeftSLine4 = function SvgMenuArrowLeftSLine4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 2.667h12V4H2V2.667Zm0 4.667h12v1.333H2V7.334ZM2 12h12v1.334H2V12Z",
    fill: "#fff"
  })));
};
export default SvgMenuArrowLeftSLine4;